import AccountSettingsConnector from '../components/settings/AccountSettingsConnector';
import AppConnector from '../components/AppConnector';
import AuthPageRouteConnector from '../components/auth/AuthPageRouteConnector';
import DataRequestAuthConnector from '../components/auth/dataRequest/DataRequestAuthConnector';
import DataRequestConfirmationConnector from '../components/auth/dataRequest/DataRequestConfirmationConnector';
import CouponLoader from '../components/coupon/CouponLoader';
import Error404 from '../components/errors/404';
import FavoritesConnector from '../components/favorites/FavoritesConnector';
import LandingConnector from '../components/landing/LandingConnector';
import OauthRouteConnector from '../components/auth/oauthProvider/OauthAuthConnector';
import OauthConfirmationRouteConnector from '../components/auth/oauthProvider/OauthConfirmationConnector';
import PaymentInformationRoute from '../components/subscription/PaymentInformationRoute';
import ProfileConnector from '../components/profile/ProfileConnector';
import RadioRouteConnector from '../components/RadioRouteConnector';
import RenewRouteConnector from '../components/subscription/RenewRouteConnector';
import ResetPasswordConnector from '../components/auth/ResetPasswordConnector';
import RootCategoryConnector from '../components/browse/RootCategoryConnector';
import SearchConnector from '../components/search/SearchConnector';
import SubscribeRouteConnector from '../components/subscription/SubscribeRouteConnector';
import UserRouteConnector from '../components/user/UserRouteConnector';
import PaymentCompletionConnector from '../components/payment/PaymentCompletionConnector';
import MetricsRouteConnector from '../components/metrics/MetricsRouteConnector';
import OptOutLoader from '../components/consent/shared/OptOutLoader';
import PinCodeConnector from '../components/auto/PinCodeConnector';

import {
  ACCOUNT_DEVICES_PATH,
  ACCOUNT_NEW_RESET_PATH,
  ACCOUNT_PATH,
  ACCOUNT_PAYMENT_PATH,
  AUTHORIZE_CONFIRM_PATH,
  AUTHORIZE_PATH,
  AUTO_PATH,
  COUPON_PATH,
  DATA_PATH,
  DATA_REQUEST_AUTH_PATH,
  DATA_REQUEST_CONFIRM_PATH,
  LOGIN_PATH,
  OPT_OUT_PATH,
  PAYMENT_COMPLETE_PATH,
  RENEW_PATH,
  SUBSCRIBE_PATH,
  UPDATE_PAYMENT_PATH,
  USER_FAVORITES_PATH,
  USER_PATH,
} from '../constants/paths';

import authViewTypes from '../constants/auth/viewTypes';

import {
  devicesTab,
  generalTab,
  subscriptionTab,
} from '../components/settings/getLinks';
import {
  albumRouteValidator,
  artistRouteValidator,
  radioRouteValidator,
} from './utils/routeValidators';
import vanityRoutes from './vanityRoutes';
import legacyRedirects from './legacyRedirects';

export default () => [
  {
    component: AppConnector,
    routes: [
      {
        path: '/',
        exact: true,
        component: LandingConnector,
        routeLevelProps: {
          isLanding: true, // needed on server for redirect
          isOverlayablePage: true,
          bgColor: 'white',
        },
      },
      {
        path: '/album/:guideIdentifier',
        component: ProfileConnector,
        routeLevelProps: {
          isOverlayablePage: true,
          routeValidator: albumRouteValidator,
        },
      },
      {
        path: '/artist/:guideIdentifier',
        component: ProfileConnector,
        routeLevelProps: {
          isOverlayablePage: true,
          routeValidator: artistRouteValidator,
        },
      },
      {
        path: '/radio/:guideIdentifier',
        component: RadioRouteConnector, // use if route is unclear if profile or browse
        routeLevelProps: {
          isOverlayablePage: true,
          routeValidator: radioRouteValidator,
        },
      },
      {
        path: '/desc/:guideIdentifier',
        component: RadioRouteConnector, // use if route is unclear if profile or browse
        routeLevelProps: {
          isOverlayablePage: true,
          routeValidator: radioRouteValidator,
          disableRedirects: true,
        },
      },
      {
        // it seems that there are podcast redirects already on the server
        path: '/podcasts/:podcastGenre/:podcastGuideIdentifier',
        component: RadioRouteConnector,
        routeLevelProps: {
          isOverlayablePage: true,
        },
      },
      {
        path: '/podcasts/:podcastGuideIdentifier',
        component: RadioRouteConnector,
        routeLevelProps: {
          isOverlayablePage: true,
        },
      },
      {
        path: '/podcasts',
        component: RootCategoryConnector,
        routeLevelProps: {
          isOverlayablePage: true,
        },
      },
      {
        path: '/search/:seoMeta?',
        component: SearchConnector,
        routeLevelProps: {
          isSearchPage: true,
        },
      },
      {
        path: AUTHORIZE_PATH,
        component: OauthRouteConnector,
        exact: true,
        routeLevelProps: {
          hidePlayer: true,
          hideAds: true,
          hideLeft: true,
          hideRight: true,
          hideFooter: true,
          isMinimalHeader: true,
          unlinkedLogo: true,
          auth: {
            viewType: authViewTypes.signIn,
          },
        },
      },
      {
        path: AUTHORIZE_CONFIRM_PATH,
        component: OauthConfirmationRouteConnector,
        exact: true,
        routeLevelProps: {
          hidePlayer: true,
          hideAds: true,
          hideLeft: true,
          hideRight: true,
          hideFooter: true,
          isMinimalHeader: true,
          unlinkedLogo: true,
          auth: {
            viewType: authViewTypes.signIn,
          },
        },
      },
      {
        path: AUTO_PATH,
        component: PinCodeConnector,
        exact: true,
        routeLevelProps: {
          hidePlayer: true,
          hideAds: true,
          hideLeft: true,
          hideRight: true,
          hideFooter: true,
          isMinimalHeader: false,
          unlinkedLogo: true,
          restrictAuthLinksAndDialog: true,
        },
      },
      {
        path: DATA_REQUEST_AUTH_PATH,
        component: DataRequestAuthConnector,
        exact: true,
        routeLevelProps: {
          hidePlayer: true,
          hideAds: true,
          hideLeft: true,
          hideRight: true,
          hideFooter: true,
          auth: {
            viewType: authViewTypes.verify,
          },
        },
      },
      {
        path: DATA_REQUEST_CONFIRM_PATH,
        component: DataRequestConfirmationConnector,
        exact: true,
        routeLevelProps: {
          hidePlayer: true,
          hideAds: true,
          hideLeft: true,
          hideRight: true,
          hideFooter: true,
        },
      },
      // legacyRedirects needs to come before
      // /account and /subscribe
      ...legacyRedirects,
      {
        path: LOGIN_PATH,
        component: AuthPageRouteConnector,
        routeLevelProps: {
          hideFooter: true,
          hideRight: true,
          restrictAuthLinksAndDialog: true,
        },
      },
      {
        path: ACCOUNT_NEW_RESET_PATH,
        component: ResetPasswordConnector,
        routeLevelProps: {
          hideRight: true,
          restrictAuthLinksAndDialog: true,
          auth: {
            viewType: authViewTypes.resetPassword,
          },
        },
      },
      {
        path: SUBSCRIBE_PATH,
        component: SubscribeRouteConnector,
        routeLevelProps: {
          hideFooter: true,
          hideRight: true,
          hideRightSideTillXxl: true,
        },
      },
      {
        path: RENEW_PATH,
        component: RenewRouteConnector,
        routeLevelProps: {
          hideFooter: true,
          hideRight: true,
          hideRightSideTillXxl: true,
        },
      },
      {
        path: UPDATE_PAYMENT_PATH,
        component: PaymentInformationRoute,
        routeLevelProps: {
          hideFooter: true,
          hideRight: true,
          hideRightSideTillXxl: true,
        },
      },
      {
        path: ACCOUNT_PATH,
        component: AccountSettingsConnector,
        routeLevelProps: {
          hideRightSidebarUpsell: true,
          settingsTab: generalTab,
          auth: {
            viewType: authViewTypes.signIn,
          },
        },
      },
      {
        path: ACCOUNT_DEVICES_PATH,
        component: AccountSettingsConnector,
        routeLevelProps: {
          hideRightSidebarUpsell: true,
          settingsTab: devicesTab,
          auth: {
            viewType: authViewTypes.signIn,
          },
        },
      },
      {
        path: ACCOUNT_PAYMENT_PATH,
        component: AccountSettingsConnector,
        routeLevelProps: {
          hideRightSidebarUpsell: true,
          settingsTab: subscriptionTab,
          auth: {
            viewType: authViewTypes.signIn,
          },
        },
      },
      {
        path: PAYMENT_COMPLETE_PATH,
        component: PaymentCompletionConnector,
        routeLevelProps: {
          hideFooter: true,
          hideRight: true,
          hideRightSideTillXxl: true,
        },
      },
      {
        path: COUPON_PATH,
        component: CouponLoader,
        routeLevelProps: {
          noHeader: true,
          bgColor: 'white',
          hideLeft: true,
          hideRight: true,
          hideFooter: true,
          hideAds: true,
        },
      },
      {
        path: USER_PATH,
        component: UserRouteConnector,
        exact: true,
        routeLevelProps: {
          isUserPage: true,
        },
      },
      {
        path: USER_FAVORITES_PATH,
        component: FavoritesConnector,
        routeLevelProps: {
          isUserPage: true,
        },
      },
      {
        path: DATA_PATH,
        component: MetricsRouteConnector,
        routeLevelProps: {
          hidePlayer: true,
          hideAds: true,
          hideRightSidebarUpsell: true,
        },
      },
      {
        path: OPT_OUT_PATH,
        component: OptOutLoader,
        exact: true,
        routeLevelProps: {
          hideLeft: true,
          hideRight: true,
          hideFooter: true,
        },
      },
      ...vanityRoutes,
      {
        path: '/*',
        component: Error404,
        routeLevelProps: {
          is404: true, // server check
        },
      },
    ],
  },
];
